module.exports = __webpack_public_path__ + "img/17.0ec4a616.jpg";